document.addEventListener('DOMContentLoaded', function() {
  const faqQuestions = document.querySelectorAll('.pro-qus-faq');

  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      this.classList.toggle('active');
      const answer = this.nextElementSibling;
      answer.classList.toggle('an-active');
    });
  });
});
